module.exports = __webpack_public_path__ + "img/usa-respiratory-diseases-female.06a64a18.png";